import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

type Props = {
  open: boolean;
  requestNo: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export function TransferCloseDialog({
  open,
  requestNo,
  loading,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && !loading && onClose()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>ປິດງານຄຳຂໍ</DialogTitle>
          <DialogDescription>
            {requestNo} — ສາຂາຮັບຄົບແລ້ວ · ຢືນຢັນປິດຂັ້ນຕອນນີ້
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            ກັບຄືນ
          </Button>
          <Button isLoading={loading} onClick={() => void onConfirm()}>
            ຢືນຢັນປິດງານ
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
